var map = {
	"./dutch": 7948,
	"./dutch.js": 7948,
	"./dutch.js.map": 1350,
	"./english": 6194,
	"./english.js": 6194,
	"./english.js.map": 2176,
	"./german": 4950,
	"./german.js": 4950,
	"./german.js.map": 2584,
	"./italian": 8338,
	"./italian.js": 8338,
	"./italian.js.map": 7344,
	"./portugese": 5828,
	"./portugese.js": 5828,
	"./portugese.js.map": 7722,
	"./spanish": 5154,
	"./spanish.js": 5154,
	"./spanish.js.map": 8640,
	"./swedish": 3867,
	"./swedish.js": 3867,
	"./swedish.js.map": 8073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8383;